import React from 'react';
import { withTranslation } from 'react-i18next';
import './ControlsPage.css';
import {TweenMax} from "gsap";
import {Quart, Quint, Linear} from "gsap";
import NextIconW from '../images/forward-w-icon.svg';
import PrevIconW from '../images/backward-w-icon.svg';

class ControlsPage extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      
    };
  }

  nextFn = (event) => {
    event.preventDefault();
  }

  prevFn = (event) => {
    event.preventDefault();
  }

  mouseOver = (event) => {
    TweenMax.to(event.currentTarget, .2, {y: -5, ease: Linear.easeNone});
  }

  mouseOut = (event) => {
    TweenMax.to(event.currentTarget, .2, {y: 0, ease: Linear.easeNone});
  }

  render () {

    const { t } = this.props;

    return (
        <div className='container-fluid controls-page'>
            <div className='row'>
                <div className='col-lg-12 col-uno'>
                    <a href={this.props.prev} className='prev-page' onMouseOver={this.mouseOver} onMouseOut={this.mouseOut}>
                        <img src={PrevIconW}></img>
                        <span>{t('controls.anterior')}</span>
                    </a>
                    <a href={this.props.next} className='next-page' style={{ display: (this.props.next == '#') ? 'none' : 'block' }} onMouseOver={this.mouseOver} onMouseOut={this.mouseOut}>
                        <span>{t('controls.siguiente')}</span>
                        <img src={NextIconW}></img>
                    </a>
                </div>
            </div>
        </div>
    );
  }
}

export default withTranslation()(ControlsPage);